module.exports = __webpack_public_path__ + "static/media/help9.c37975b2.png";